import { STEP_DONE } from './constants';

export const getStepPath = (
  propertyType: string,
  step: number | 'DONE',
): string => {
  const stepName = step === 'DONE' ? STEP_DONE : `STEP_${step}`;
  return `/property_type_steps/${propertyType}/${stepName}.svg`;
};
